/**
 * 紐付商品単位に商品情報を取得するために使用するVO
 *
 */
export class GetGoodsDataModel {

  public processDiv: string = <string>'';	// 処理区分

  public orderCode: string = <string>'';	// 受注コード
  public mediumType: string = <string>'';	// 媒体区分
  public mainPCode: string = <string>'';	// 代表商品コード

  public pCode: string = <string>'';	// 紐付商品コード
  public index: number;		// 入力行
}
